module.exports = __webpack_public_path__ + "img/eth-logo.a972f87b.png";